<template>
    <button
        class="py-2 px-4 hover:bg-primary hover:bg-opacity-10 rounded-md"
        @click="toggleMenu"
        ref="buttonRef"
    >
        <slot></slot>
    </button>
    <Teleport to="body" v-show="isOpen">
        <div
            class="
                fixed
                top-0
                left-0
                right-0
                bottom-0
                z-10
                bg-white bg-opacity-10
            "
            v-if="isOpen"
            @click.self="toggleMenu"
        ></div>
        <div
            role="menu"
            ref="menuRef"
            class="
                flex flex-col
                gap-2
                bg-white
                shadow-2xl
                min-w-[150px]
                rounded-lg
                py-4
                text-sm
                z-20
            "
            v-show="isOpen"
        >
            <button
                class="py-2 px-4 text-left hover:bg-primary hover:bg-opacity-10"
                v-for="item in items"
                @click="
                    emit('action', item);
                    toggleMenu();
                "
            >
                {{ item.label }}
            </button>
        </div>
    </Teleport>
</template>

<script setup>
import { ref } from "vue";
import { createPopper } from "@popperjs/core";

const toggleMenu = () => {
    isOpen.value = !isOpen.value;
    if (isOpen.value) {
        createPopper(buttonRef.value, menuRef.value, {
            placement: "bottom-start",
        }).forceUpdate();
    }
};

const buttonRef = ref(null);
const menuRef = ref(null);

const isOpen = ref(false);
const props = defineProps(["items"]);
const emit = defineEmits(["action"]);
</script>
